import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getCategories = state => state.h24Categories

export const selectCategoriesFetching = state => path(['h24Categories', 'isFetching'], state)

export const selectCategories = createSelector(getCategories, categories => {
    if (!(isEmpty(categories.entities) || isEmpty(categories.result))) {
        const items = categories.entities.categories
        return categories.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/hotels24Selectors/h24Categories.js